import { PayloadAction } from '../../../store.model';
import { ActionType } from '../transcript-dialog.action';
import { TranscriptDialogState } from '../transcript-dialog.state';

import { Reset } from './reset.action';

// TODO revise. use reload instead???
export function resetReducer(
    state: TranscriptDialogState,
    _: PayloadAction<ActionType.COACHING_DETAIL__TD__RESET, Reset>,
): TranscriptDialogState {
    try {
        return {
            ...state,
            pending: {},
            filteredQuotes:
                state.transcript?.entries != null
                    ? [...state.transcript.entries]
                    : [],
            filterOpts: {},
            sliderOptions: {
                floorNum: 0,
                ceilNum:
                    state.transcript?.entries == null ||
                    state.transcript.entries.length === 0
                        ? 1
                        : (state.transcript.entries.at(-1)?.endTime?.getTime() -
                              state.transcript.entries[0]?.endTime?.getTime()) /
                          1000,
            },
            selectedQuotes: undefined,
            filteredQuotesSelectedLookup: {},
            allQuotesAreSelected: undefined,
        };
    } catch (err) {
        console.log(err);
        return state;
    }
}
